'use client';
import cn from 'classnames';

import './RichText.style.scss';
import { CSSProperties } from 'react';

type RichTextProps = {
  className?: string;
  children: string;
  style?: CSSProperties;
};

/**
 * A component used to render Builder input type of `richText`
 * @param props.children
 * @returns
 */
function RichText(props: RichTextProps) {
  const { className = '', children, style = {} } = props;

  return (
    <div
      className={cn('RichText', className)}
      dangerouslySetInnerHTML={{ __html: children }}
      style={style}
    />
  );
}

export default RichText;
